import { makeAutoObservable } from "mobx";

export default class WorkingScheduleStore {

    constructor() {
        makeAutoObservable(this);
    }

   
}